import { IconButton, makeStyles, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  span_button: {
    padding: 3,
    display: "inline-flex",
    verticalAlign: "middle",
  },
});

interface IProp {
  [property: string]: any;

  /** Título do botão que será exibido no tooltip. */
  title: string;
  /** Propriedade arialabel do botão. */
  ariaLabel: string;
  /** Função que será executada no ao clicar no botão. */
  onClick?: Function;
  /** Conteúdo do elemento botão. */
  children: any;
}

/** Botão da coluna 'Ação' de tabelas. Já montado com o tooltip do título.
 * @category Components */
const ActionButton = ({
  title,
  ariaLabel,
  onClick,
  children,
  disabled,
  ...props
}: IProp) => {
  const classes = useStyles();
  return (
    <Tooltip title={title} arrow>
      {disabled ? (
        <span className={classes.span_button}>{children}</span>
      ) : (
        <IconButton
          {...props}
          size="small"
          aria-label={ariaLabel}
          onClick={(ev) => {
            if (onClick) onClick(ev);
          }}
        >
          {children}
        </IconButton>
      )}
    </Tooltip>
  );
};

ActionButton.propsType = {
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default ActionButton;
